import React, { Component } from 'react';
import styled from 'styled-components';

import TimesGridAppStarter from './app/TimesGridAppStarter';
import parseDoctorLocationIds from './app/utils/parseDoctorLocationIds';
import BaseDesktopTimesGridControls from './views/DesktopTimesGridControls';
import DesktopTimesGridContent from './views/DesktopTimesGridContent';
import MobileTimesGridContent from './views/MobileTimesGridContent';
import MobileTimesGridControls from './views/MobileTimesGridControls';

const DesktopTimesGridControls = styled(BaseDesktopTimesGridControls)`
    margin-bottom: 8px;
    padding-bottom: 8px;
`;

/**
 * TimesGrid renders one times grid controls with one times grid content.
 */
@TimesGridAppStarter
export default class ControlsAndContent extends Component {
    render() {
        const doctorLocationId = parseDoctorLocationIds(this.props.doctorLocationIds)[0];

        if (this.props.isMobile) {
            return this.renderMobileControlsAndContent(doctorLocationId);
        }

        return this.renderDesktopControlsAndContent(doctorLocationId);
    }

    renderMobileControlsAndContent(doctorLocationId) {
        return (
            <div data-test="ap-mobile">
                <MobileTimesGridControls {...this.props} />
                <MobileTimesGridContent
                    {...this.props}
                    doctorLocationId={doctorLocationId}
                />
            </div>
        );
    }

    renderDesktopControlsAndContent(doctorLocationId) {
        const { isWellGuideView } = this.props;
        return (
            <TimesGridWrapper
                data-test="ap-desktop"
                isWellGuideView={isWellGuideView}
            >
                <DesktopTimesGridControls {...this.props} />
                <DesktopTimesGridContent
                    {...this.props}
                    doctorLocationId={doctorLocationId}
                    isWellGuideView={isWellGuideView}
                />
            </TimesGridWrapper>
        );
    }
}

const TimesGridWrapper = styled.div`
    ${p => p.isWellGuideView ? 'background-color: #F6F6F6;' : ''}
    ${p => p.isWellGuideView ? 'margin: 0 30px;' : ''}
`;
